/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
import { EmailSchema } from './Email.schema';
import { AddressSchema } from './Address.schema';
import { PhoneNumberSchema } from './PhoneNumber.schema';
import { WebsiteSchema } from './Website.schema';
const baseSchema = z.object({
    slug: z.string().min(1, { message: "Slugs must be between 1 and 100 characters." }).max(100, { message: "Slugs must be between 1 and 100 characters." }).regex(new RegExp("^[A-Za-z0-9-]+$"), { message: "Slugs must contain only letters, numbers, and hyphens" }).nullish(),
    createdAt: z.coerce.date().default(() => new Date()),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    businessName: z.string().trim().min(1, { message: "Business name must be between 1 and 100 characters." }).max(100, { message: "Business name must be between 1 and 100 characters." }),
    emails: z.array(z.lazy(() => EmailSchema)),
    addresses: z.array(z.lazy(() => AddressSchema)),
    phoneNumbers: z.array(z.lazy(() => PhoneNumberSchema)),
    websites: z.array(z.lazy(() => WebsiteSchema)),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    slug: z.string().min(1, { message: "Slugs must be between 1 and 100 characters." }).max(100, { message: "Slugs must be between 1 and 100 characters." }).regex(new RegExp("^[A-Za-z0-9-]+$"), { message: "Slugs must contain only letters, numbers, and hyphens" }).nullish(),
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    businessName: z.string().trim().min(1, { message: "Business name must be between 1 and 100 characters." }).max(100, { message: "Business name must be between 1 and 100 characters." }),
    emails: z.array(z.lazy(() => EmailSchema)),
    addresses: z.array(z.lazy(() => AddressSchema)),
    phoneNumbers: z.array(z.lazy(() => PhoneNumberSchema)),
    websites: z.array(z.lazy(() => WebsiteSchema)),
}
).strict();
const relationSchema = z.object({
    organization: z.record(z.string(), z.unknown()),
    listings: z.array(z.unknown()).optional(),
}
);
const fkSchema = z.object({
    organizationId: z.string(),
}
);

/**
 * `Business` schema excluding foreign keys and relations.
 */
export const BusinessScalarSchema = baseSchema;


/**
 * `Business` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const BusinessSchema = BusinessScalarSchema.merge(fkSchema).merge(relationSchema.partial());


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const BusinessPrismaCreateSchema = baseSchemaWithoutDefaults.partial().passthrough();


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const BusinessPrismaUpdateSchema = z.object({
    slug: z.string().min(1, { message: "Slugs must be between 1 and 100 characters." }).max(100, { message: "Slugs must be between 1 and 100 characters." }).regex(new RegExp("^[A-Za-z0-9-]+$"), { message: "Slugs must contain only letters, numbers, and hyphens" }).nullish(),
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    businessName: z.string().trim().min(1, { message: "Business name must be between 1 and 100 characters." }).max(100, { message: "Business name must be between 1 and 100 characters." }),
    emails: z.array(z.lazy(() => EmailSchema)),
    addresses: z.array(z.lazy(() => AddressSchema)),
    phoneNumbers: z.array(z.lazy(() => PhoneNumberSchema)),
    websites: z.array(z.lazy(() => WebsiteSchema))
}).partial().passthrough();


/**
 * `Business` schema for create operations excluding foreign keys and relations.
 */
export const BusinessCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true, createdById: true, updatedAt: true, updatedById: true, id: true, emails: true, addresses: true, phoneNumbers: true, websites: true
});


/**
 * `Business` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const BusinessCreateSchema = BusinessCreateScalarSchema.merge(fkSchema);


/**
 * `Business` schema for update operations excluding foreign keys and relations.
 */
export const BusinessUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `Business` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const BusinessUpdateSchema = BusinessUpdateScalarSchema.merge(fkSchema.partial());

